import gql from 'graphql-tag';

export default gql`
  query {
    languageState @client {
      locale
    }
  }
`;



// WEBPACK FOOTER //
// ./app/components/LocalizedRouter/graphql/getlocale.gql.js